// extracted by mini-css-extract-plugin
module.exports = {"text":"story-descriptions_text__2cOi8"};